import { render, staticRenderFns } from "./RevenueReportSumTable.vue?vue&type=template&id=21ceb171&scoped=true"
import script from "./RevenueReportSumTable.vue?vue&type=script&lang=js"
export * from "./RevenueReportSumTable.vue?vue&type=script&lang=js"
import style0 from "./RevenueReportSumTable.vue?vue&type=style&index=0&id=21ceb171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ceb171",
  null
  
)

export default component.exports